<template>
  <div>
    <home-one />
  </div>
</template>

<script>
import HomeOne from "../components/Home/index";
export default {
  components: { HomeOne },
  mounted () {
  window.scrollTo(0, 0)
}
};
</script>

<style>
</style>